import { render } from "./AvatarSmall.vue?vue&type=template&id=20517ab7"
import script from "./AvatarSmall.vue?vue&type=script&lang=js"
export * from "./AvatarSmall.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__